import '.bz{flex-shrink:0;}.ssr-plugin'
import '.c0{padding:1rem;}.ssr-plugin'
import '.y{width:100%;}.ssr-plugin'
import '.bh{height:100%;}.ssr-plugin'
import '.au{border:none;}.ssr-plugin'
import '.av{background-color:transparent;}.ssr-plugin'
import '.ec{border-radius:0px;}.ssr-plugin'
import '.h{display:flex;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.a9{align-items:stretch;}.ssr-plugin'
import '.d1{position:sticky;}.ssr-plugin'
import '.ed{top:4rem;}.ssr-plugin'
import '.ee{z-index:7;}.ssr-plugin'
import '.ac{background-color:var(--shades-white);}.ssr-plugin'
import '.ef{padding-bottom:1rem;}.ssr-plugin'
import '.a3{margin-bottom:1rem;}.ssr-plugin'
import '.eg{border-bottom:var(--blue-border);}.ssr-plugin'
import '.s{position:fixed;}.ssr-plugin'
import '.cq{top:0px;}.ssr-plugin'
import '.bf{left:0px;}.ssr-plugin'
import '.bg{right:0px;}.ssr-plugin'
import '.eh{bottom:0px;}.ssr-plugin'
import '.ei{z-index:9999;}.ssr-plugin'
import '.ej{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.dg{justify-content:flex-end;}.ssr-plugin'
import '.c1{flex:1;}.ssr-plugin'
import '.aq{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="bz c0 y bh au av ec"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="h i a9"
    >
      <div className="d1 ed ee ac ef a3 eg h"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="s cq bf bg eh ei ac ej h i"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="c0 h dg eg"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="c1 aq">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
